import style from "../css/Popup2.module.css";
import exit from "../img/component/admin_exit.svg";
import popupImg from "../img/popup/popup0507.jpg";

export default function Popup2({setPopup}) {

    function closePopup() {
        setPopup(false);
    }

    function closeToday() {
        const expire = new Date();
        const expireDate = expire.getDate();
        localStorage.setItem('Visit_Cookie_ent2', expireDate);
        setPopup(false);
    }
    return(
        <div className={ style.popupWrap }>
            <div className={ style.popupContainer }>
                <div className={ style.popupHeader }>
                    <img src={ exit } alt="exit" onClick={ closePopup }></img>
                </div>
                <div className={ style.popupBody }>
                    <div className={style.popupCnt}>
                        <img src={popupImg}/>
                        {/*<h2>기준일 설정 공고</h2>*/}
                        {/*<p>상법 제 354조 및 당사 정관 규정에 따라 2024년 4월 23일 현재 주주명부에 기재되어 있는 주주에게 당사와 주식회사 블레이드뮤직과의 소규모합병에 대한*/}
                        {/*    반대의사표시를 할 수 있는 권리를 부여하기 위하여 기준일 설정을 공고합니다</p>*/}
                        {/*<div>*/}
                        {/*    <p>2024년 4월 8일 </p>*/}
                        {/*    <address>주식회사 블레이드엔터테인먼트</address>*/}
                        {/*    <address>충청북도 증평군 증평읍 광장로 473-3</address>*/}
                        {/*    <address>주식회사 블레이드엔터테인먼트</address>*/}
                        {/*    <p>대표이사 홍 상 혁</p>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className={style.popupFooter}>
                    <span onClick={closeToday}>오늘하루 그만보기</span>
                </div>
            </div>
        </div>
    )
}